"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _useClickAway = _interopRequireDefault(require("react-use/lib/useClickAway"));
var _styles = require("@material-ui/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _SearchInput = _interopRequireDefault(require("../Input/SearchInput/SearchInput"));
var _excluded = ["children", "className", "component", "dangerouslySetInnerHTML", "dataset", "draggableProps", "index", "onClick", "onMouseDown", "onMouseUp", "placeholder", "spacing", "styles", "text"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var useStyles = (0, _styles.makeStyles)({
  searchInput: {
    padding: 0,
    width: '18rem !important',
    backgroundColor: 'inherit !important'
  }
});
var MasterDetailSearchInput = function MasterDetailSearchInput(props /*: Props*/) {
  var ref = React.useRef(null);
  // Support optional chaining (https://github.com/facebook/flow/issues/4303)
  // $FlowIgnore
  (0, _useClickAway.default)(ref, function () {
    var _ref$current, _ref$current$blur;
    return ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : (_ref$current$blur = _ref$current.blur) === null || _ref$current$blur === void 0 ? void 0 : _ref$current$blur.call(_ref$current);
  });
  // Omit props that Atlaskit passes that are not valid element attributes
  var children = props.children,
    className = props.className,
    component = props.component,
    dangerouslySetInnerHTML = props.dangerouslySetInnerHTML,
    dataset = props.dataset,
    draggableProps = props.draggableProps,
    index = props.index,
    onClick = props.onClick,
    _onMouseDown = props.onMouseDown,
    _onMouseUp = props.onMouseUp,
    placeholder = props.placeholder,
    spacing = props.spacing,
    styles = props.styles,
    text = props.text,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(_SearchInput.default, (0, _extends2.default)({
    className: (0, _classnames.default)(className, classes.searchInput),
    inputRef: ref,
    onMouseDown: function onMouseDown(event) {
      // Stop the event from bubbling to Atlaskit `InteractionStateManager` component
      // (https://bitbucket.org/atlassian/atlaskit-mk-2/src/be4cdd0b1f9566847c274d0d05b9549881e0ae4a/packages/core/navigation-next/src/components/presentational/InteractionStateManager/index.js#lines-22)
      event.stopPropagation();
      if (typeof _onMouseDown === 'function') _onMouseDown(event);
    },
    onMouseUp: function onMouseUp(event) {
      // Stop the event from bubbling to Atlaskit `InteractionStateManager` component
      // (https://bitbucket.org/atlassian/atlaskit-mk-2/src/be4cdd0b1f9566847c274d0d05b9549881e0ae4a/packages/core/navigation-next/src/components/presentational/InteractionStateManager/index.js#lines-17)
      event.stopPropagation();
      if (typeof _onMouseUp === 'function') _onMouseUp(event);
    },
    placeholder: placeholder
  }, other));
};
MasterDetailSearchInput.displayName = 'MasterDetailSearchInput';
var _default = exports.default = MasterDetailSearchInput;
//# sourceMappingURL=MasterDetailSearchInput.js.map